import { toTicketFormValues } from "@/helpers/ticketing.helpers"

import type {
  TicketIssueActionPayload,
  TicketIssueExtra
} from "@/api/useWorkflow.types"
import type { TicketFormValues } from "@/helpers/ticketing.helpers.types"

// A new template starts from the vendor's default title and description
export const getInitialTemplateValues = (
  existingTemplate?: TicketIssueActionPayload,
  extra?: TicketIssueExtra
): Partial<TicketFormValues> => {
  if (existingTemplate)
    return {
      ...toTicketFormValues(existingTemplate.fields),
      onDemandFields: existingTemplate.onDemandFields || {}
    }

  const { title, summary, description } = extra?.defaultIssueTemplate || {}

  return { title: title || summary || "", description: description || "" }
}
